import getFullDate from 'utils/getInfo/getFullDate';

const getPDFNotification = (employerEmail: string = '', employerName: string = '', date: string = ''): string => (
  `Email sent. (TAO form has been signed by ${employerName}) ${employerEmail}, Jon.p@joblio.co, aleksandra@joblio.co, mtower@joblio.co, gbretsen@joblio.co, yana.g@joblio.co, ${getFullDate(date)}`
);

export default getPDFNotification;
